import React from "react";
import styled from "styled-components/macro";

export const Wrapper = styled.svg`
  display: block;
  aspect-ratio: 1/1;
  height: auto;
  width: auto;
`;

export default () => {
  return (
    <Wrapper
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        id="icon-search"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.7415 10.3275L15.707 14.293L14.293 15.707L10.3275 11.7415C9.2525 12.529 7.9315 13 6.5 13C2.916 13 0 10.084 0 6.5C0 2.916 2.916 0 6.5 0C10.084 0 13 2.916 13 6.5C13 7.932 12.529 9.2525 11.7415 10.3275ZM6.5 1C3.4675 1 1 3.4675 1 6.5C1 9.5325 3.4675 12 6.5 12C9.5325 12 12 9.5325 12 6.5C12 3.4675 9.5325 1 6.5 1Z"
        fill="#999999"
      />
    </Wrapper>
  );
};
